<template>
  <section class="refer-information-page">
    <h1>New Refer Case Support Ticket</h1>
    <span>Based on the information previously provided, a refer case had to be made to quote. </span>
    <div class="abs-top-right">
      <v-button @click="back">Previous</v-button>
      <v-button
        type="primary"
        @click="handlerCreate">{{ isReferralRequest? 'Convert': 'Create' }}</v-button>
    </div>
    <housemaid-quote-refer-info
      v-if="productId == 12"
      :formData="formData" />
    <decoration-quote-refer-info
      v-else-if="productId == 15"
      :formData="formData" />
    <homefire-quote-refer-info
      v-else-if="productId == 17"
      :formData="formData" />
    <fire-quote-refer-info
      v-else-if="productId == 20"
      :formData="formData" />
    <student-quote-refer-info
      v-else-if="productId == 16"
      :formData="formData" />
    <travel-quote-refer-info
      v-else-if="productId == 14"
      :formData="formData" />
    <working-quote-refer-info
      v-else-if="productId == 13"
      :formData="formData" />
    <personal-quote-refer-info
      v-else-if="productId == 18"
      :formData="formData" />
    <pet-quote-refer-info
      v-else-if="productId == 22"
      :formData="formData" />
    <template v-else>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Information</span>
        </div>
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ formData.pcy_cmnt_date }}</span>
        </div>
        <template v-if="formData.class_id !== 14">
          <div class="tr">
            <span>Insurance Type</span>
            <span>{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured</span>
            <span>{{ formData.isrd_vl }}</span>
          </div>
          <div class="tr">
            <span>Hire Purchase Owner</span>
            <span>{{ getOptionName('yesNoOptions', formData.hp_ind) }}</span>
          </div>
          <div class="tr">
            <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
            <span v-if="!isMortgagorOther">{{ getLocalAllOptionName('mortgagor', formData.mortgagor)}}</span>
            <span v-else>{{  formData.mortgagor_other}}</span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
          <!--            <span >{{ getOptionName('yesNoOptions', formData.no_acci_nor_deduct) }}</span>-->
          <!--          </div>-->

        </template>
        <template v-if="formData.class_id==11&&extraBenefitSelect.length>0">
          <div class="tr">
            <span>Extra Benefits</span>
            <span>
              <span
                v-for="(item,index) in extraBenefitSelect"
                :key="'extra'+index">{{item.name}}<br></span>
            </span>
          </div>
        </template>
      </div>
      <div class="box">
        <h2>Car Detail</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <template v-if="formData.class_id == 14">
            <div class="tr">
              <span>Registration Mark</span>
              <span>{{ formData.rgtn_no }}</span>
            </div>
            <div class="tr">
              <span>Car Type</span>
              <span>{{ getOptionName('classOptions', classId) }}</span>
            </div>
            <div class="tr">
              <span>Car Make</span>
              <span>{{ getLocalAllOptionName('brand', formData.brand_id) }}</span>
            </div>
            <div class="tr">
              <span>Car Model</span>
              <span>{{ formData.rgtn_mdl }}</span>
            </div>
            <div class="tr">
              <span>Body Type</span>
              <span>{{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }}</span>
            </div>
            <div class="tr">
              <span>Year of Manufacture</span>
              <span>{{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }}</span>
            </div>
            <div class="tr">
              <span>Cylinder Capacity</span>
              <span>{{ formData.engn_cpcty }} cc</span>
            </div>
            <div class="tr">
              <span>Seating Capacity ( excl. driver)</span>
              <span>{{ formData.no_of_seats }}</span>
            </div>
            <div class="tr">
              <span>Chassis Number</span>
              <span>{{ formData.chasis_no }}</span>
            </div>
            <div class="tr">
              <span>Engine Number</span>
              <span>{{ formData.engn_no }}</span>
            </div>
            <div class="tr">
              <span>NCD</span>
              <span>{{ getLocalAllOptionName('ncd', formData.ncd_pct) }}</span>
            </div>
            <div class="tr">
              <span>Coverage</span>
              <span>{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>
            </div>
            <div class="tr">
              <span>Will the vehicle be used for commercial purpose?</span>
              <span>{{ getAllOptionName('mc_usage', formData.usage_ind) }}</span>
            </div>
            <!--            <div class="tr">-->
            <!--              <span>What kind of commercial usage?</span>-->
            <!--              &lt;!&ndash; <span>In addition to social, domestic, pleasure use and by the proposer for business purposes, will the vehicle be used for</span> &ndash;&gt;-->
            <!--              <span class="child-span-block">-->
            <!--                <span-->
            <!--                  v-for="(item, index) in businessPurposes"-->
            <!--                  :key="index"-->
            <!--                  class="red">-->
            <!--                  {{ item.name }}-->
            <!--                </span>-->
            <!--              </span>-->
            <!--            </div>-->
            <div class="tr">
              <span>Is there any modification in the above vehicle</span>
              <span class="red">{{ getOptionName('yesNoOptions', formData.car_modified_ind) }}</span>
            </div>
            <div class="tr">
              <span>Is the vehicle fitted with Car Camcorder?</span>
              <span>{{ getOptionName('yesNoOptions', formData.car_camcorder_ind) }}</span>
            </div>
            <!--            <div class="tr">-->
            <!--              <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
            <!--              <span >{{ getOptionName('yesNoOptions', formData.no_acci_nor_deduct) }}</span>-->
            <!--            </div>-->
            <div class="tr">
              <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
              <span >{{ getOptionName('yesNoOptions', formData.no_dr_acci_ind) }}</span>
            </div>
            <div class="tr">
              <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>
              <span >{{ getOptionName('yesNoOptions', formData.no_dr_deduct_ind) }}</span>
            </div>
          </template>
          <template v-else>
            <div class="tr">
              <span>Registration Mark</span>
              <span>{{ formData.rgtn_no }}</span>
            </div>
            <div class="tr">
              <span>Year of Manufacture</span>
              <span>{{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }}</span>
            </div>
            <div class="tr">
              <span>Car Make</span>
              <span>{{ getLocalAllOptionName('brand', formData.brand_id) }}</span>
            </div>
            <div
              v-if="classId == 12"
              class="tr">
              <span>Car Model</span>
              <span>{{ formData.rgtn_mdl }}</span>
            </div>
            <div
              v-else
              class="tr">
              <span>Car Model</span>
              <!--              <span>{{ getOptionName('carModelOptions', formData.model_id) }}</span>-->
              <span>{{  formData.model }}</span>
            </div>
            <div class="tr">
              <span>Body Type</span>
              <span v-if="classId == 12">{{ formData.rgtn_typ_of_bdy }}</span>
              <span v-else>{{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }}</span>
            </div>
            <div
              class="tr">
              <span v-if="classId == 11">Cylinder Capacity</span>
              <span v-else>Cylinder Capacity (Input "0" for EV)</span>
              <span>{{ formData.engn_cpcty }} cc</span>
            </div>
            <section v-if="classId == 11">
              <div
                class="tr">
                <span>Seating Capacity ( excl. driver)</span>
                <span>{{ formData.no_of_seats }}</span>
              </div>
              <div class="tr">
                <span>Chassis Number</span>
                <span>{{ formData.chasis_no }}</span>
              </div>
              <div class="tr">
                <span>Engine Number</span>
                <span>{{ formData.engn_no }}</span>
              </div>
              <div class="tr">
                <span>Car Usage</span>
                <span>{{ getOptionName('usageOptions', formData.usage_ind) }}</span>
              </div>
              <div class="tr">
                <span>What kind of commercial usage?</span>
                <!-- <span>In addition to social, domestic, pleasure use and by the proposer for business purposes, will the vehicle be used for</span> -->
                <span class="child-span-block">
                  <span
                    v-for="(item, index) in businessPurposes"
                    :key="index"
                    class="red">
                    {{ item.name }}
                  </span>
                </span>
              </div>
              <div class="tr">
                <span>Is there any modification in the above vehicle</span>
                <span class="red">{{ getOptionName('yesNoOptions', formData.car_modified_ind) }}</span>
              </div>
              <!--              <div class="tr">-->
              <!--                <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
              <!--                <span >{{ getOptionName('yesNoOptions', formData.no_acci_nor_deduct) }}</span>-->
              <!--              </div>            -->
              <div class="tr">
                <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
                <span >{{ getOptionName('yesNoOptions', formData.no_dr_acci_ind) }}</span>
              </div>
              <div class="tr">
                <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>
                <span >{{ getOptionName('yesNoOptions', formData.no_dr_deduct_ind) }}</span>
              </div>
            </section>
            <section v-else>
              <div
                class="tr">
                <span>Permitted Gross Vehicle Weight</span>
                <span>{{ formData.tonnage }}</span>
              </div>
              <div
                class="tr">
                <span>Seating Capacity ( excl. driver)</span>
                <span>{{ formData.no_of_seats }}</span>
              </div>
              <div class="tr">
                <span>Chassis Number</span>
                <span>{{ formData.chasis_no }}</span>
              </div>
              <div class="tr">
                <span>Engine Number</span>
                <span>{{ formData.engn_no }}</span>
              </div>
              <div class="tr">
                <span>Is there any modification in the above vehicle</span>
                <span class="red">{{ getOptionName('yesNoOptions', formData.car_modified_ind) }}</span>
              </div>
              <div class="tr">
                <span>Is the vehicle fitted with Car Camcorder?</span>
                <span class="red">{{ getOptionName('yesNoOptions', formData.car_camcorder_ind) }}</span>
              </div>
              <div
                v-if="classId==12"
                class="tr">
                <span>Will the vehicle be used by third party for carrying goods for reward?</span>
                <span class="red">{{ getOptionName('yesNoOptions', formData.use_carrying_profit_ind) }}</span>
              </div>
              <!--              <div class="tr">-->
              <!--                <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
              <!--                <span >{{ getOptionName('yesNoOptions', formData.no_acci_nor_deduct) }}</span>-->
              <!--              </div>-->
              <div class="tr">
                <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
                <span >{{ getOptionName('yesNoOptions', formData.no_dr_acci_ind) }}</span>
              </div>
              <div class="tr">
                <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>
                <span >{{ getOptionName('yesNoOptions', formData.no_dr_deduct_ind) }}</span>
              </div>
            </section>
            <div class="tr">
              <span>NCD</span>
              <span>{{ getLocalAllOptionName('ncd', formData.ncd_pct) }}</span>
            </div>
            <div v-if="formData.ncd_pct>0">
              <div class="tr">
                <span>Previous Insurance Company</span>
                <span>{{ getLocalAllOptionName('latest_insurance_company', formData.prev_insurer_nm) }}</span>
              </div>
              <div class="tr">
                <span>Previous Registration Number</span>
                <span>{{ formData.prev_rgtn_no }}</span>
              </div>
              <div class="tr">
                <span>Previous Policy Number</span>
                <span>{{formData.prev_pcy_no }}</span>
              </div>
              <div
                class="tr">
                <span>Is the subject Insured vehicle be the same as the one under the previous policy?</span>
                <span>{{ getOptionName('yesNoOptions',formData.is_same_car) }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="box">
        <h2>Policyholder Details</h2>
        <div class="table">
          <template v-if="formData.cust_typ == 1">
            <div class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div class="tr">
              <span>Title</span>
              <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
            </div>
            <div class="tr">
              <span>Last Name</span>
              <span>{{ formData.isrd_lst_nm }}</span>
            </div>
            <div class="tr">
              <span>First Name</span>
              <span>{{ formData.isrd_fst_nm }}</span>
            </div>
            <div class="tr">
              <span>Date of Birth</span>
              <span>{{ formData.isrd_dob_date }}</span>
            </div>
            <div class="tr">
              <span>HKID Card No. / Passport No.</span>
              <span>{{ getOptionName('idTypeOptions', formData.id_type) }}</span>
            </div>
            <div class="tr">
              <span>ID Number</span>
              <span>{{ formData.id_no }}</span>
            </div>
            <div class="tr">
              <span>Mobile Number</span>
              <span>{{ formData.mobile_no }}</span>
            </div>
            <div class="tr">
              <span>Email</span>
              <span>{{ formData.email }}</span>
            </div>
            <div class="tr">
              <span>Occupation</span>
              <span>{{ formData.occ }}</span>
            </div>
            <div
              v-if="classId != 14"
              class="tr">
              <span>Policyholder is one of the Named Driver?</span>
              <span>{{ getOptionName('yesNoOptions', formData.hldr_is_drvr_ind) }}</span>
            </div>
          </template>
          <template v-else>
            <div class="tr">
              <span>Company Name</span>
              <span>{{ formData.isrd_com_nm }}</span>
            </div>
            <div class="tr">
              <span>Business Registration Number</span>
              <span>{{ formData.id_no }}</span>
            </div>
            <div class="tr">
              <span>Company Phone No.</span>
              <span>{{ formData.phone_no }}</span>
            </div>
            <div class="tr">
              <span>Company Email</span>
              <span>{{ formData.email }}</span>
            </div>
            <div class="tr">
              <span>Nature of Business</span>
              <span>{{ getLocalAllOptionName('industry', formData.bsns_nature_id) }}</span>
            </div>
            <div class="tr">
              <span>Name</span>
              <span>{{ formData.contact_nm }}</span>
            </div>
            <div class="tr">
              <span>Occupation & Position</span>
              <span>{{ getLocalAllOptionName('occupation', formData.contact_occ_id) }}</span>
            </div>
            <div class="tr">
              <span>Phone No.</span>
              <span>{{ formData.contact_phone }}</span>
            </div>
            <div class="tr">
              <span>Email</span>
              <span>{{ formData.contact_email }}</span>
            </div>
          </template>
          <div class="tr">
            <span>Room</span>
            <span>{{ formData.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ formData.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ formData.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ formData.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ formData.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', formData.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', formData.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', formData.addr_region) }}</span>
          </div>
        </div>
      </div>
      <div class="box">
        <h2>Named Driver Information</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Number of Driver(s)</span>
            <span>{{ formData.no_of_nm_drvr }}</span>
          </div>
        </div>
        <div class="table">
          <div class="tr th">
            <span>Information</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">Driver {{ index+1 }}</span>
          </div>
          <div class="tr">
            <span>Relationship with Proposer</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_rel_language }}
              <!-- {{ getLocalAllOptionName('relation', item.nm_drvr_rel) }} -->
            </span>
          </div>
          <div class="tr">
            <span>Title</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">{{ getOptionName('titleOptions', item.nm_drvr_title) }}</span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_lst_nm }}
            </span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_fst_nm }}
            </span>
          </div>
          <div class="tr">
            <span>Date of Birth</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_dob_date }}
            </span>
          </div>
          <div class="tr">
            <span>HKID Card No. / Passport No.</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ getOptionName('idTypeOptions', item.nm_drvr_id_type) }}
            </span>
          </div>
          <div class="tr">
            <span>ID Number</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_id_no }}
            </span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ getLocalAllOptionName('occupation', item.nm_drvr_occ_id) }}
            </span>
          </div>
          <div class="tr">
            <span>Driving Experience</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{
                classId == 14?
                  getLocalAllOptionName('dr_lic_of_own', item.nm_drvr_exp):
                  getLocalAllOptionName('drvr_exp', item.nm_drvr_exp) }}
            </span>
          </div>
          <div class="tr">
            <span>HKID Card File</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_id_type_pic_url? 'idfile.pdf': '' }}
            </span>
          </div>
          <div class="tr">
            <span>Driving Licence File</span>
            <span
              v-for="(item, index) in formData.nm_drvr_list"
              :key="index">
              {{ item.nm_drvr_licence_pic_url? 'licensefile.pdf': '' }}
            </span>
          </div>
        </div>
      </div>
      <div class="box">
        <h2>Documents</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Policyholder HKID</span>
            <span @click="openFile(formData.id_type_pic.url)">{{ formData.id_type_pic? 'file.pdf': '' }}</span>
          </div>
          <div class="tr">
            <span>Vehicle Registration Documen</span>
            <span @click="openFile(formData.rgtn_pic.url)">{{ formData.rgtn_pic? 'file.pdf': '' }}</span>
          </div>
          <div class="tr">
            <span>NCB proof (e.g. Renewal Notice)</span>
            <span @click="openFile(formData.ncd_proof.url)">{{ formData.ncd_proof? 'file.pdf': '' }}</span>
          </div>
          <div
            v-for="(item, index) in formData.other_file"
            :key="index"
            class="tr">
            <span>Additional Documents</span>
            <span @click="openFile(item.url)">file.pdf</span>
          </div>
        </div>
      </div>
    </template>

  </section>
</template>
<script>
// import { getOrderDetail } from '@/api/order'
import {
  getCarQuoteDetail,
  getHomefireQuoteDetail,
  getHousemaidQuoteDetail,
  getInteriorQuoteDetail,
  getStudentQuoteDetail,
  getTravelQuoteDetail,
  getWorkingQuoteDetail,
  getPersonalQuoteDetail,
  getPetQuoteDetail,
} from '@/api/quote'
import {addReferral} from '@/api/refer'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import HousemaidQuoteReferInfo from './modules/housemaid/quote-refer-info'
import DecorationQuoteReferInfo from './modules/decoration/quote-refer-info'
import HomefireQuoteReferInfo from './modules/homefire/quote-refer-info'
import fireQuoteReferInfo from './modules/homefire/fire-quote-refer-info'
import TravelQuoteReferInfo from './modules/travel/quote-refer-info'
import StudentQuoteReferInfo from './modules/student/quote-refer-info'
import PersonalQuoteReferInfo from './modules/personal/quote-refer-info'
import WorkingQuoteReferInfo from './modules/working/quote-refer-info'
import petQuoteReferInfo from './modules/pet/quote-refer-info'

import {convertReferralRequestRefer} from '@/api/request'

export default {
  name: 'QuoteReferInformation',
  components: {
    HousemaidQuoteReferInfo,
    DecorationQuoteReferInfo,
    HomefireQuoteReferInfo,
    fireQuoteReferInfo,
    TravelQuoteReferInfo,
    StudentQuoteReferInfo,
    WorkingQuoteReferInfo,
    PersonalQuoteReferInfo,
    petQuoteReferInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    requestOrderId: {
      type: Number,
      default: 0
    },
    referralRequestId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      formData: {
        business_purposes: [],
        driversTable: [
          {
            label: 'Relationship with Proposer',
            key: 'nm_drvr_rel'
          },
          {
            label: 'Title',
            key: '',
          },
          {
            label: 'Last Name',
            key: '',
          },
          {
            label: 'First Name',
            key: '',
          },
          {
            label: 'Date of Birth',
          },
          {
            label: 'HKID Card No. / Passport No.',
          },
          {
            label: 'ID Number',
          },
          {
            label: 'Occupation',
          },
          {
            label: 'Driving Experience',
          },
          {
            label: 'HKID Card File',
            ifFile: true,
            fileName: 'idfile.pdf'
          },
          {
            label: 'Driving Licence File',
            ifFile: true,
            fileName: 'licensefile.pdf'
          },
        ]
      }
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('quote', ['carModelOptions', 'quoteInformationForm']),
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    classId() {
      return this.formData.class_id || 14
    },
    orderId() {
      if(this.isReferralRequest) return this.requestOrderId
      return this.$route.query.order_id
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposes() {
      return this.localAllOptions.business_purposes.filter(item => {
        return this.formData.business_purposes.includes(item.id)
      })
    },
    isMortgagorOther(){
      let motorList = this.localAllOptions.mortgagor
      let {mortgagor}=this.formData
      let list = motorList.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    }
  },
  watch: {
    'formData.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && this.classId == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    }
  },
  created() {
    let {product_id} = this.$route.query||{}
    console.log('product_id-',product_id)
    switch(Number(this.productId||product_id)) {
      case 12:
        this.network().getHousemaidQuoteDetail()
        break
      case 11:
        this.network().getCarQuoteDetail()
        break
      case 16:
        this.network().getStudentQuoteDetail()
        break
      case 14:
        this.network().getTravelQuoteDetail()
        break
      case 15:
        this.network().getInteriorQuoteDetail()
        break
      case 13:
        this.network().getWorkingQuoteDetail()
        break
      case 17:
        this.network().getHomefireQuoteDetail()
        break
      case 18:
        this.network().getPersonalQuoteDetail()
        break
      case 20:
        this.network().getHomefireQuoteDetail()
        break
      case 22:
        this.network().getPetQuoteDetail()
        break
    }
  },
  methods: {
    ...mapActions('quote', ['updateCarModelOptions','setIsBack']),
    isShowQuestion(){
      let {prev_insurer_nm,company_id} = this.formData||{}
      let pre_insurance = this.globalOptions.latest_insurance_company||[]
      pre_insurance =pre_insurance.filter(item=> item.id == prev_insurer_nm)
      if(pre_insurance.length>0)
      {
        return  pre_insurance[0].hc_cp_id==company_id
      }else
        return false
    },
    openFile(url) {
      window.open(url, '_blank')
    },
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    handlerCreate() {
      if(this.isReferralRequest) {
        this.network().convertReferralRequestRefer()
        return
      }
      this.network().addReferral(this.quoteInformationForm)
    },
    back(){

      if(this.isReferralRequest) {
        this.$emit('back')
        return
      }

      this.setIsBack(true)
      this.$router.replace(
        {
          path:'/records/quote/detail',
          query:{
            order_id: this.orderId,
            product_id: this.productId,
          }
        }
      )
    },
    network() {
      return {
        // getOrderDetail: async () => {
        //   let { data } = await getOrderDetail({
        //     order_id: this.$route.query.order_id
        //   })
        //   this.formData = data
        // },
        getCarQuoteDetail: async () => {
          let { data } = await getCarQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getHousemaidQuoteDetail: async () => {
          let { data } = await getHousemaidQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getInteriorQuoteDetail: async () => {
          let { data } = await getInteriorQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getHomefireQuoteDetail: async () => {
          let { data } = await getHomefireQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getPersonalQuoteDetail: async () => {
          let { data } = await getPersonalQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getStudentQuoteDetail: async () => {
          let { data } = await getStudentQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getTravelQuoteDetail: async () => {
          let { data } = await getTravelQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getWorkingQuoteDetail: async () => {
          let { data } = await getWorkingQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        getPetQuoteDetail: async () => {
          let { data } = await getPetQuoteDetail({
            order_id: this.orderId
          })
          this.formData = data
        },
        addReferral: async (params) => {
          let { data } = await addReferral(params)
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.ticket_id
            }
          })
        },
        convertReferralRequestRefer: async () => {
          const { data } = await convertReferralRequestRefer({
            ...this.quoteInformationForm,
            referral_request_id: this.referralRequestId
          })
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.refer-information-page {
    position: relative;
    padding-right: 200px;
    h1 {
      padding-bottom: 5px;
      & + span {
        display: block;
        padding-bottom: 10px;
      }
    }
}
</style>
